export default __webpack_public_path__ + "static/media/plate.674934d0.png";